import { PurchaseData } from 'storage/types';
import { createNewPurchaseData, getPurchase } from 'storage/purchaseStore';

// Dates are full ISO timestamps, but a purchase belongs to a calendar day.
const isSameVisitDay = (a: string, b: string): boolean =>
  a.split('T')[0] === b.split('T')[0];

/**
 * LEGACY — silently starts an empty cart when `date` differs from the stored one. Only
 * the old /date → /sell → /tickets flow depends on that; it goes when those routes do.
 * New code uses `getPurchase` / `getOrCreatePurchase` from storage/purchaseStore.
 */
export const getOrCreatePurchaseData = (date: string): PurchaseData => {
  const purchase = getPurchase();
  if (!purchase) return createNewPurchaseData(date);
  return isSameVisitDay(purchase.date, date) ? purchase : createNewPurchaseData(date);
};

export default getOrCreatePurchaseData;
